import React from 'react';
interface BrandMarkProps {
  inverted?: boolean;
}
export function BrandMark({
  inverted = false
}: BrandMarkProps) {
  return <div className="flex items-center justify-center gap-2.5" data-id="element-21" data-mp="yhm2bml346dc">
      <span className={`flex h-9 w-9 items-center justify-center rounded-xl ${inverted ? 'bg-white/10' : 'bg-ink'}`} data-id="element-22" data-mp="tissc450axhx">
        <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" aria-hidden="true" data-id="element-23" data-mp="om2elngocdzo">
          <path d="M9 3.5C6.2 3.5 4 5.9 4 9c0 5.2 3.4 9.6 7 11.5V8.5" stroke="#1a9ed9" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" data-id="element-24" data-mp="1h96mq1b2d8fo" />
          <path d="M15 3.5c2.8 0 5 2.4 5 5.5 0 5.2-3.4 9.6-7 11.5V8.5" stroke="#ffffff" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" data-id="element-25" data-mp="17jvcgbcfxxq7" />
        </svg>
      </span>
      <span className={`font-display text-[19px] font-bold tracking-tight ${inverted ? 'text-white' : 'text-ink'}`} data-id="element-26" data-mp="205oak7msko6n">
        Renal Decision Desk
        <sup className="ml-0.5 text-[9px] align-super" data-id="element-27" data-mp="18tqv6i067skw">™</sup>
      </span>
    </div>;
}